import { ROOT_PATH, CIAM_REGISTRATION_PATH, AUTH0_ERROR_PATH } from './constants';

export const getCompanyQueryParams = (companyUid, companyUri) => {
  if (companyUid === undefined && companyUri === undefined) {
    return null;
  }
  return companyUid === companyUri ? `${companyUid}` : `${companyUid}?uri=${companyUri}`;
};

export const checkIfPathIsAuth0ErrorPage = path => path === AUTH0_ERROR_PATH;

export const checkIfUserAccessRootPath = path => {
  if (path === ROOT_PATH || path === CIAM_REGISTRATION_PATH) {
    return true;
  }
  return false;
};

export const checkUserSessionUrl = () => {
  const path = sessionStorage.getItem('userPath');
  if (path) {
    sessionStorage.removeItem('userPath');
  }
  return path;
};

export const saveUserSessionPath = path => {
  sessionStorage.setItem('userPath', path);
};
